import { Configuration, FrontendApi } from "@ory/client";

const kratosUrl = import.meta.env.VITE_ORY_API_URL || "http://localhost:4433";

export function ory(): FrontendApi {
  return new FrontendApi(
    new Configuration({
      basePath: kratosUrl,
      baseOptions: {
        withCredentials: true,
      },
    }),
  );
}
